<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      scrollable
      persistent
      style="background-color: #red"
    >
      <v-container fluid class="full-height">
        <v-row style="background-color: #ceefed">
          <v-col>
            <v-card style="min-height: 100vh" class="card-detail ml-1">
              <v-card-title class="justify-space-between pa-4">
                <v-btn
                  v-if="checkRole == 'เภสัชกร'"
                  icon
                  large
                  elevation="2"
                  @click="Pharmacy_back"
                >
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <v-spancer></v-spancer>
                <v-btn
                  v-if="closeCapture"
                  @click="captureScreen()"
                  color="#00a99d"
                  dark
                  style="border-radius: 8px"
                >
                  <v-icon class="mr-2">mdi-monitor-screenshot</v-icon>
                  screenshot</v-btn
                >
              </v-card-title>
              <v-card-text>
                <!-- <v-btn v-else icon large elevation="2" @click="back">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn> -->
                <iframe
                  class="iframe"
                  allow="camera *; microphone; display-capture"
                  frameBorder="0"
                  :src="detailConference.data.conference_url"
                  scrolling="no"
                ></iframe>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col
            cols="4"
            v-show="checkRole == 'แพทย์'"
            v-if="checkRole == 'แพทย์'"
          >
            <v-card class="card-detail mr-1 ml-0" style="min-height: 100vh">
              <v-tabs
                color="#00a99d"
                class="elevation-0"
                v-model="currentItem"
                show-arrows
                grow
                center-active
              >
                <v-tabs-slider></v-tabs-slider>

                <v-tab class="tab pb-2"> บันทึกการรักษา </v-tab>
                <v-tab
                  class="tab pb-2"
                  v-if="
                    take_drug == true &&
                    check_biz_id !== '42354740940858985' &&
                    check_biz_id !== '34026259424998'
                  "
                >
                  สั่งรายการยา
                </v-tab>
              </v-tabs>
              <div class="my-4">
                <v-tabs-items v-model="currentItem" class="full-height-tab">
                  <v-tab-item eager
                    ><v-container>
                      <div class="align-center">
                        <span
                          class="pl-2"
                          style="
                            font-size: 18px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                          >บันทึกการรักษา</span
                        >
                      </div>

                      <v-row class="pa-0 ma-0">
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการสำคัญ </span>
                            <v-text-field
                              v-model="marjor_symptoms"
                              solo
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> อาการปัจจุบัน </span>
                            <v-text-field
                              solo
                              v-model="current_symptoms"
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> โรคประจำตัว </span>
                            <v-text-field
                              solo
                              v-model="congenital_disease"
                              hide-details="auto"
                              dense
                              placeholder="กรอกข้อมูล"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col cols="12">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">
                              บันทึกทางการแพทย์
                            </span>
                            <v-textarea
                              auto-grow
                              v-model="medical_record"
                              solo
                              dense
                              hide-details="auto"
                              placeholder="กรอกข้อมูล"
                            ></v-textarea>
                          </div>
                        </v-col>
                        <v-col cols="12" v-if="screenShot">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> รูปภาพ </span>
                            <div v-if="screenShot" class="pt-2">
                              <img
                                :src="screenShot"
                                alt="Video Screenshot"
                                class="screenshot-img"
                              />
                            </div>
                          </div>
                        </v-col>
                        <v-col
                          cols="12"
                          v-if="
                            check_biz_id == '42354740940858985' ||
                            check_biz_id == '34026259424998'
                          "
                        >
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">
                              ต้องการพบเภสัช
                            </span>
                            <v-radio-group v-model="conf_pharmacist">
                              <v-radio label="พบเภสัช" :value="true"></v-radio>
                              <v-radio
                                label="ไม่พบเภสัช"
                                :value="false"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-col>
                        <v-col cols="12" v-else>
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> ต้องการรับยา </span>
                            <v-radio-group
                              v-model="take_drug"
                              @change="chooseDrug"
                            >
                              <v-radio label="รับยา" :value="true"></v-radio>
                              <v-radio
                                label="ไม่รับยา"
                                :value="false"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-col
                      cols="12"
                      v-if="
                        check_biz_id !== '42354740940858985' ||
                        check_biz_id == '34026259424998'
                      "
                    >
                      <div class="d-flex justify-end pt-3">
                        <v-btn
                          width="30%"
                          dark
                          color="#00a99d"
                          @click="currentItem = 1"
                          v-if="take_drug == true"
                          >ถัดไป
                        </v-btn>
                      </div>
                    </v-col>
                  </v-tab-item>
                  <v-tab-item eager>
                    <v-container>
                      <div class="align-center">
                        <span
                          class="pl-2"
                          style="
                            font-size: 18px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                          >รายการยา</span
                        >
                      </div>

                      <v-row class="pa-0 ma-0">
                        <v-col cols="12">
                          <div class="d-flex align-center">
                            <span
                              class="pr-2"
                              style="
                                font-size: 14px;
                                font-weight: bold;
                                color: #00a99d;
                              "
                            >
                              ข้อมูลรายการยา
                            </span>
                            <v-divider
                              class="mt-1"
                              style="background-color: #ceefed"
                            ></v-divider>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row
                        v-for="(drug, index) in itemDrug"
                        :key="index"
                        class="pl-2 pr-2"
                      >
                        <v-col class="pa-1" cols="5">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">
                              #{{ index + 1 }} รายการยา
                            </span>
                            <v-autocomplete
                              solo
                              hide-details="auto"
                              dense
                              :items="itemSearchDrug"
                              @keyup="searchDrugList"
                              @input="(e) => setDrug(e, index, 'list')"
                              v-model="itemDrug[index].drug_name"
                              return-object
                              item-text="name_drug"
                              item-value="name_drug"
                              placeholder="กรอกรายการยา"
                            >
                              <template v-slot:no-data>
                                <v-list-item>
                                  <v-list-item-title>
                                    ไม่พบข้อมูล
                                  </v-list-item-title>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </div>
                        </v-col>
                        <v-col class="pa-1" cols="2" align="center">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px"> จำนวน</span>
                            <v-text-field
                              type="number"
                              solo
                              hide-details="auto"
                              dense
                              @keypress="handleKeyPress"
                              @input="(e) => setDrug(e, index, 'count')"
                              v-model="itemDrug[index].count"
                              placeholder="กรอกจำนวน"
                              :min="0"
                              :max="CheckQuantity(itemDrug[index])"
                              oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
                              :rules="[
                                (v) =>
                                  (v >= 0 &&
                                    v <= CheckQuantity(itemDrug[index])) ||
                                  'ยาไม่พอ',
                              ]"
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col class="pa-1" cols="2" align="center">
                          <div class="d-flex flex-column">
                            <span style="font-size: 16px">ราคา</span>
                            <v-text-field
                              solo
                              hide-details="auto"
                              dense
                              v-model="itemDrug[index].sum"
                              readonly
                            ></v-text-field>
                          </div>
                        </v-col>
                        <v-col class="pa-1" cols="3" align="center">
                          <div class="d-flex flex-column">
                            <div class="d-flex">
                              <span style="font-size: 16px">ราคารวม</span>
                              <v-spacer></v-spacer>
                              <v-btn icon x-small @click="delDrug(index)">
                                <v-icon color="red">mdi-close</v-icon>
                              </v-btn>
                            </div>
                            <v-text-field
                              solo
                              hide-details="auto"
                              dense
                              :value="priceTakingMedicine(itemDrug[index])"
                              small
                              readonly
                            ></v-text-field>
                          </div>
                        </v-col>

                        <!-- ข้อมูลการรับยา -->
                        <v-col
                          class="pa-1"
                          cols="1"
                          align-self="center"
                        ></v-col>
                        <v-col class="pl-2 pr-2" cols="12" align-self="center">
                          <v-row class="usageAndAdvice" v-show="show">
                            <v-col
                              class="pa-1"
                              cols="12"
                              align-self="center"
                              style="white-space: wrap; text-overflow: ellipsis"
                            >
                              <span class="w-700 font-14 text-313B41">
                                จำนวนยาในคลัง :
                              </span>
                              <span class="w-300 font-14 text-313B41"
                                >{{ itemDrug[index].list_drug.quantity }}
                              </span>
                              <span>
                                {{ itemDrug[index].list_drug.unit }}
                              </span>
                            </v-col>
                          </v-row>
                          <v-col
                            class="pa-1"
                            cols="1"
                            align-self="center"
                          ></v-col>
                          <v-row class="usageAndAdvice" v-show="show">
                            <v-col
                              class="pa-1"
                              cols="12"
                              align-self="center"
                              style="white-space: wrap; text-overflow: ellipsis"
                            >
                              <span class="w-700 font-14 text-313B41">
                                ข้อมูลการใช้ยา :
                              </span>
                              <span class="w-300 font-14 text-313B41"
                                >{{
                                  itemDrug[index].list_drug.usage
                                    ? itemDrug[index].list_drug.usage
                                    : "-"
                                }}
                              </span>
                            </v-col>
                            <v-col
                              class="pa-1"
                              cols="12"
                              align-self="center"
                              style="text-align: center"
                            >
                              <span class="w-700 font-12 text-EB5757">
                                ***
                                {{
                                  itemDrug[index].list_drug.advice
                                    ? itemDrug[index].list_drug.advice
                                    : "ไม่มี"
                                }}
                                ***
                              </span>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-col cols="12" lg="12" class="text-right">
                        <v-btn icon @click="addDrug">
                          <v-icon color="#00a99d">mdi-plus-circle</v-icon>
                        </v-btn>
                      </v-col>

                      <v-row class="pl-2 pr-2 pt-3">
                        <v-col class="pa-1" cols="7">
                          <span class="w-300 font-18 text-313B41"
                            >สรุปรายการยา {{ quantity(itemDrug) }} รายการ</span
                          >
                        </v-col>
                        <v-col class="pa-1" cols="5" align="end">
                          <span class="w-300 font-18 text-313B41"
                            >ราคารวม
                          </span>
                          <span class="w-300 font-18 text-3D85E1">
                            <!-- {{ itemDrug[0].sum }} -->
                            {{ netprice(itemDrug) }}
                          </span>
                          <span class="w-300 font-18 text-313B41"> บาท</span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-tab-item>
                  <v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        class="mr-2"
                        width="30%"
                        outlined
                        color="#00a99d"
                        @click="back"
                        >ย้อนกลับ</v-btn
                      >
                      <v-btn width="30%" dark color="#00a99d" @click="save"
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col>
                </v-tabs-items>
              </div>
            </v-card>
          </v-col>
          <v-col
            cols="4"
            v-show="checkRole == 'เภสัชกร'"
            v-if="checkRole == 'เภสัชกร'"
          >
            <v-card class="card-detail mr-1 ml-0" style="min-height: 100vh">
              <v-tabs
                color="#00a99d"
                class="elevation-0"
                v-model="currentItem"
                show-arrows
                grow
                center-active
              >
                <v-tabs-slider></v-tabs-slider>
                <v-tab class="tab pb-2" v-show="take_drug">
                  สั่งรายการยา
                </v-tab>
              </v-tabs>
              <div class="my-4">
                <v-tabs-items v-model="currentItem" class="full-height-tab">
                  <v-tab-item eager>
                    <v-container>
                      <div class="align-center">
                        <span
                          class="pl-2"
                          style="
                            font-size: 18px;
                            font-weight: bold;
                            color: #00a99d;
                          "
                          >รายการยา</span
                        >
                      </div>
                      <v-row class="pa-0 ma-0">
                        <v-col cols="12">
                          <div class="d-flex align-center">
                            <span
                              class="pr-2"
                              style="
                                font-size: 14px;
                                font-weight: bold;
                                color: #00a99d;
                              "
                            >
                              ข้อมูลรายการยา
                            </span>
                            <v-divider
                              class="mt-1"
                              style="background-color: #ceefed"
                            ></v-divider>
                          </div>
                        </v-col>
                      </v-row>
                      <div v-if="itemHistory.drug_list.length !== 0">
                        <v-row
                          class="ma-0 pa-0"
                          v-for="(item, index) in itemHistory.drug_list"
                          :key="index"
                        >
                          <v-col class="pa-1" cols="6">
                            <div>
                              <span style="font-size: 16px"
                                >#{{ index + 1 }} รายการยา</span
                              >
                              <span class="w-300 font-18 text-313B41">
                                <v-text-field
                                  class="text-field"
                                  :value="item.name_drug"
                                  outlined
                                  dense
                                  small
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </span>
                            </div>
                          </v-col>
                          <v-col class="pa-1" cols="2">
                            <div>
                              <span style="font-size: 16px"> จำนวน</span>
                              <span
                                class="w-300 font-18 text-313B41"
                                v-if="check_biz_id == '668236676897760'"
                              >
                                <v-text-field
                                  class="text-field"
                                  v-model="item.quantity"
                                  outlined
                                  dense
                                  small
                                  readonly
                                  hide-details
                                  :min="0"
                                ></v-text-field>
                              </span>
                              <span class="w-300 font-18 text-313B41" v-else>
                                <v-text-field
                                  class="text-field"
                                  v-model="item.count"
                                  outlined
                                  dense
                                  small
                                  readonly
                                  hide-details
                                  :min="0"
                                ></v-text-field>
                              </span>
                            </div>
                          </v-col>
                          <v-col class="pa-1" cols="2" align="center">
                            <div>
                              <span style="font-size: 16px">ราคา</span>
                              <span class="w-300 font-18 text-313B41">
                                <v-text-field
                                  class="text-field"
                                  :value="item.price"
                                  outlined
                                  dense
                                  small
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </span>
                            </div>
                          </v-col>
                          <v-col
                            class="pa-1"
                            cols="2"
                            align="center"
                            text-align="center"
                          >
                            <div>
                              <span style="font-size: 16px">ราคารวม</span>
                              <span class="w-300 font-18 text-313B41">
                                <v-text-field
                                  class="text-field"
                                  :value="totalToFixed(item.total)"
                                  outlined
                                  dense
                                  small
                                  readonly
                                  hide-details
                                ></v-text-field>
                              </span>
                            </div>
                          </v-col>
                          <v-col class="pa-1" cols="12">
                            <v-row class="usageAndAdvice">
                              <v-col
                                class="pa-1"
                                cols="12"
                                style="
                                  white-space: wrap;
                                  text-overflow: ellipsis;
                                "
                              >
                                <span class="w-700 font-14 text-313B41">
                                  ข้อมูลการใช้ยา :
                                </span>
                                <span class="w-300 font-14 text-313B41">
                                  {{ item.usage || "-" }}
                                </span>
                              </v-col>
                              <v-col
                                class="pa-1"
                                cols="12"
                                align-self="center"
                                style="text-align: center"
                                v-if="item.advice"
                              >
                                <span class="w-700 font-12 text-EB5757">
                                  ***
                                  {{ item.advice }}
                                  ***
                                </span>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col cols="12"></v-col>
                        </v-row>
                        <v-col cols="12" class="d-flex justify-center">
                          <span
                            >สรุปยอดรายการยา
                            {{ sumprice(itemHistory) }} บาท</span
                          >
                        </v-col>
                      </div>
                      <div v-else>
                        <v-row class="pa-3 ma-0"
                          ><v-col
                            cols="12"
                            class="noitems d-flex justify-center align-center"
                          >
                            <h2>ไม่มีข้อมูลรายการยา</h2>
                          </v-col>
                        </v-row>
                      </div>
                    </v-container>
                  </v-tab-item>
                  <v-col cols="12">
                    <div class="d-flex justify-end pt-3">
                      <v-btn
                        class="mr-2"
                        width="30%"
                        outlined
                        color="#00a99d"
                        @click="Pharmacy_back"
                        >ย้อนกลับ</v-btn
                      >
                      <v-btn
                        v-show="check_biz_id == '668236676897760'"
                        width="30%"
                        dark
                        color="#00a99d"
                        @click="save_Pharmacy"
                        >บันทึก</v-btn
                      >
                    </div>
                  </v-col>
                </v-tabs-items>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Swal from "sweetalert2";
// import Tab1MedicalRecords from "../views/TabConference/Tab1MedicalRecords.vue";
// import Tab3DrugRecords from "../views/TabConference/Tab3DrugRecords.vue";
export default {
  //   components: { Tab1MedicalRecords, Tab3DrugRecords },
  data: () => ({
    tab: ["บันทึกการรักษา", "บันทึกสุขภาพ"],
    // itemHistory: [],
    currentItem: 0,
    selectDrug: true,
    dialog: false,
    marjor_symptoms: "",
    current_symptoms: "",
    congenital_disease: "",
    medical_record: "",
    check_biz_id: sessionStorage.biz_id,
    show: false,
    take_drug: true,
    conf_pharmacist: true,
    itemDrug: [
      { list_drug: {}, price: "", count: "", sum: "" },
      { list_drug: {}, price: "", count: "", sum: "" },
    ],
    itemSearchDrug: [],
    channel_name: "",
    screenshot: null,
    screenShot: null,
    screenWidth: window.innerWidth,
    screenHeight: window.innerHeight,
    closeCapture: true,
  }),
  watch: {
    itemDrug: {
      deep: true,
      handler(newVal) {
        newVal.forEach((item, index) => {
          if (isNaN(item.sum)) {
            this.$set(this.itemDrug[index], "sum", 0);
          }
        });
      },
    },
  },

  computed: {
    ...mapState(["detailConference", "queue", "itemHistory", "isCapture"]),
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    checkRole() {
      return sessionStorage.role_name;
    },
  },
  async mounted() {
    // this.getDrug();
    this.searchDrugList();
    window.addEventListener("resize", this.updateScreenSize);
    window.addEventListener("storage", this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateScreenSize);
  },
  methods: {
    ...mapMutations(["setDetailConference", "setCaptureScreen"]),
    updateScreenSize() {
      this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
    },
    handleStorageChange(event) {
      if (event.key === "isCapture") {
        const newValue = event.newValue === "true";
        this.closeCapture = newValue;
      }
    },
    openDialog() {
      this.dialog = true;
      setTimeout(() => {
        const params = new URLSearchParams();
        params.append("his_id", this.detailConference.data.his_id);
        // console.log("🚀 ~ CheckTimeConference ~ params:", params);
        this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/conferences/get_history_conference`,
            {
              params,
            }
          )
          .then((res) => {
            // console.log("res", res);
            this.channel_name = res.data.data.data.data[0].channel_name;
            console.log("🚀 ~ .then ~ this.channel_name:", this.channel_name);
          });
      }, 10 * 1000);
    },
    handleKeyPress(event) {
      const invalidChars = ["e", "E", "-", "."];
      if (invalidChars.includes(event.key)) {
        event.preventDefault();
      }
    },
    quantity(itemDrug) {
      let quantity = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "") {
          quantity++;
        }
      });
      return quantity;
    },

    netprice(itemDrug) {
      let netprice = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "" && ele.count !== "") {
          netprice += Number(ele.count) * Number(ele.price);
        }
      });
      return netprice.toFixed(2);
    },

    CheckQuantity(item) {
      if (item && item.list_drug.quantity) {
        return item.list_drug.quantity;
      } else {
        return 0;
      }
    },
    priceTakingMedicine(item) {
      let price = 0;
      if (item.count !== "") {
        price = item.count * item.price;
      }
      return price.toFixed(2);
    },
    async save() {
      const {
        congenital_disease,
        current_symptoms,
        marjor_symptoms,
        medical_record,
      } = this;
      let drug_list = [];

      //   console.log(
      //     "🚀 ~ file: Conference.vue:114 ~ save ~ $refs:",

      //     itemDrug,
      //     patient_name
      //   );
      this.itemDrug.forEach((element) => {
        if (element.price != "") {
          drug_list.push({
            ...element.list_drug,
            total: element.sum,
            count: element.count,
          });
        }
      });
      let payload;
      if (
        this.check_biz_id == "42354740940858985" ||
        this.check_biz_id == "34026259424998"
      ) {
        payload = {
          congenital_disease,
          current_symptoms,
          marjor_symptoms,
          medical_record,
          screenShot: this.screenShot,
          appointment_id: this.queue.appointment_id,
          conf_pharmacist: this.conf_pharmacist,
          drug_list,
          patient_name: this.queue.patient_name,
          biz_id: sessionStorage.biz_id,
          conference_id: this.detailConference._id,
          doctor_id: this.queue.doctor_id,
          doctor_name: this.queue.doctor_name,
        };
      } else {
        payload = {
          congenital_disease,
          current_symptoms,
          marjor_symptoms,
          medical_record,
          screenShot: this.screenShot,
          appointment_id: this.queue.appointment_id,
          take_drug: this.take_drug,
          drug_list: this.take_drug == false ? [] : drug_list,
          patient_name: this.queue.patient_name,
          biz_id: sessionStorage.biz_id,
          conference_id: this.detailConference._id,
          doctor_id: this.queue.doctor_id,
          doctor_name: this.queue.doctor_name,
        };
      }
      console.log(
        "🚀 ~ file: ConferenceTelemed.vue:717 ~ save ~ payload:",
        payload
      );
      if (this.take_drug == true && drug_list.length == 0) {
        await Swal.fire({
          title: "กรุณากรอกข้อมูลรายการยา",
          icon: "warning",
          showConfirmButton: false,
          allowOutsideClick: false,
          timer: 1000,
        });
      } else {
        const { data: { result } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-appointment`,
          payload
        );
        if (result == "success") {
          await Swal.fire({
            icon: "success",
            title: "บันทึกการรักษาสำเร็จ",
            showConfirmButton: false,
            timer: 1000,
          });
          if (drug_list.length > 0 && this.take_drug == true) {
            this.endConference();
            this.dialog = false;
            this.$emit("success_drug");
          } else {
            this.endConference();
            this.dialog = false;
            this.$emit("success");
          }
          //this.$router.push({ name: "e-vaccineMain" });
        }
        this.setCaptureScreen(true);
        console.log(
          "item >>",
          this.$refs.form1._data,
          "item2>>>",
          this.$refs.form2._data
        );
      }
    },
    async save_Pharmacy() {
      try {
        const body = {
          appointment_id: this.queue.appointment_id,
        };
        const { data: { result } = {} } = await this.axios.post(
          `${process.env.VUE_APP_BACKEND_URL}/v1/drug/finish`,
          body
        );
        if (result == "success") {
          this.$swal.fire({
            icon: "success",
            title: "บันทึกการรักษาสำเร็จ",
            showConfirmButton: false,
            timer: 1000,
          });
          this.endConference();
          this.dialog = false;
          this.$emit("success");
        }
      } catch (err) {
        console.log(err);
      }
    },
    endConference() {
      try {
        var body = {
          channel_name: this.channel_name,
        };
        this.axios
          .post(`https://meet.manageai.co.th/api/v1/calling/ending`, body)
          .then((res) => {
            console.log("🚀 ~ .then ~ res:", res);
          });
      } catch (error) {
        console.error();
      }
    },
    getChoose(choose) {
      this.selectDrug = choose;
    },
    back() {
      this.endConference();
      this.dialog = false;
      this.$emit("back");
      this.setCaptureScreen(true);
      // this.$router.go(-1);
    },
    Pharmacy_back() {
      this.endConference();
      this.dialog = false;
      this.$emit("Pharmacy_back");
      // this.$router.go(-1);
    },
    async searchDrugList(text) {
      try {
        let word = "";
        if (text === undefined) {
          word = "";
        } else word = text.target.value;
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/druglists/search?biz_id=${sessionStorage.biz_id}&search=${word}`
          )
          .then((res) => {
            this.itemSearchDrug = res.data.data[0].data;
            // console.log("itemSearchDrug", this.itemSearchDrug);
          });
        // if (data[0]) {
        //   const { data: dataSearch = {} } = data[0];
        //   this.itemSearchDrug = dataSearch;
        //   console.log("dddddddddddddddd", this.itemSearchDrug);
        // console.log(
        //   "🚀 ~ file: Tab3DrugRecords.vue:115 ~ searchDrugList ~ dataSearch:",
        //   dataSearch
        // );
        // }
        // if (result == "success") {

        // }

        // console.log("🚀 ~ file: Drug.vue:99 ~ getDrugList ~ data:", data);
      } catch (error) {
        console.error();
      }
    },
    addDrug() {
      this.itemDrug.push({ list_drug: {}, price: "", count: "", sum: "" });
    },
    delDrug(index) {
      if (index > -1) {
        // only splice array when item is found
        this.itemDrug.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    setDrug(event, index, type) {
      switch (type) {
        case "count":
          this.itemDrug[index].sum = parseFloat(
            parseFloat(this.itemDrug[index].price) * parseInt(event)
          );
          break;
        case "list":
          this.itemDrug[index].list_drug = event;
          this.itemDrug[index].count = 1;
          this.itemDrug[index].price = event.price;
          this.itemDrug[index].sum = event.price;
          this.show = true;
          break;
        case "price":
          this.itemDrug[index].price = event.price;
          break;
        default:
          break;
      }
    },
    chooseDrug() {
      this.$emit("chooseDrug", this.take_drug);
    },
    // role เภสัชกร
    totalToFixed(item) {
      return item.toFixed(2);
    },
    sumprice(itemHistory) {
      let netprice = 0;
      if (this.check_biz_id == "668236676897760") {
        if ("drug_list" in itemHistory && itemHistory.drug_list.length) {
          itemHistory.drug_list.forEach((ele) => {
            if (ele.price !== "" && ele.quantity !== "") {
              netprice += Number(ele.quantity) * Number(ele.price);
            }
          });
          return netprice.toFixed(2);
        } else {
          return 0.0;
        }
      } else {
        if ("drug_list" in itemHistory && itemHistory.drug_list.length) {
          itemHistory.drug_list.forEach((ele) => {
            if (ele.price !== "" && ele.count !== "") {
              netprice += Number(ele.count) * Number(ele.price);
            }
          });
          return netprice.toFixed(2);
        } else {
          return 0.0;
        }
      }
    },
    async captureScreen() {
      try {
        const stream = await navigator.mediaDevices.getDisplayMedia({
          video: true,
        });

        const video = document.createElement("video");
        video.srcObject = stream;

        video.onloadedmetadata = () => {
          video.play();
          setTimeout(() => {
            const canvas = document.createElement("canvas");
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            this.screenshot = canvas.toDataURL("image/png");
            stream.getTracks().forEach((track) => track.stop());
            // this.cropImage(canvas);
            this.screenShot = canvas.toDataURL("image/png");
          }, 1000);
        };
      } catch (error) {
        console.error("Error capturing screen:", error);
      }
    },
    cropImage(originalCanvas) {
      console.log("55555555555555555", this.screenWidth);
      // image ขนาดแสดงเฉพาะของผู้ป่วย
      // let cropX = 30;
      // let cropY = 400;
      // let cropWidth = 1200;
      // let cropHeight = 550;
      // if (this.screenWidth > 1707) {
      //   cropHeight = 600
      //   cropY = 350
      // }
      // else if (this.screenWidth < 1550) {
      //   cropHeight = 520
      //   cropY = 420
      // }
      // image ขนาดแสดงทั้งหน้าจอ
      let cropX = 30;
      let cropY = 250;
      let cropWidth = 1200;
      let cropHeight = 780;
      if (this.screenWidth >= 1707) {
        cropY = 250;
        cropX = 50;
        cropWidth = 1190;
      } else if (this.screenWidth >= 2048) {
        cropY = 100;
      } else if (this.screenWidth >= 3072) {
        cropY = 200;
      } else if (this.screenWidth <= 1550) {
        cropY = 280;
        cropHeight = 750;
        cropX = 50;
        cropWidth = 1180;
      }
      const croppedCanvas = document.createElement("canvas");
      croppedCanvas.width = cropWidth;
      croppedCanvas.height = cropHeight;
      const croppedCtx = croppedCanvas.getContext("2d");
      croppedCtx.drawImage(
        originalCanvas,
        cropX,
        cropY,
        cropWidth,
        cropHeight,
        0,
        0,
        cropWidth,
        cropHeight
      );
      this.screenShot = croppedCanvas.toDataURL("image/png");
      console.log("🚀 ~ cropImage ~ this.screenShot:", this.screenShot);
    },
  },
};
</script>
<style scoped>
.card-detail {
  border-radius: 20px;
}
.v-tabs-items.full-height-tab .v-window-item {
  height: calc(85vh); /* Adjust 270px to suits your needs */
  overflow-y: auto;
}
.iframe {
  width: 100%;
  height: 90vh;
}

.noitems {
  height: 70vh;
  border: 1px solid #e8e9e9;
  border-radius: 10px;
}
.usageAndAdvice {
  border: 1px solid #00000061;
  border-radius: 4px;
  margin: 0px;
}
@media only screen and (max-width: 1264px) {
  .iframe {
    width: 100%;
    height: 50vh;
  }
}

@media only screen and (max-width: 960px) {
  .iframe {
    width: 100%;
    height: 50vh;
  }
}

@media only screen and (max-width: 360px) {
  .iframe {
    width: 100%;
    height: 30vh;
  }
}

.screenshot-img {
  width: 100%;
  max-width: 450px;
  height: 250px;
  border: 2px solid #f1f1f1;
}
</style>
